import React from 'react';

import { KB_ITEM_TYPE_LABEL, KB_LIVE_COPY } from '../../constants/training';
import type { ItemRaisedData } from '../../services/kbLiveFrames';
import TrainingStatusLine from '../training/TrainingStatusLine';

interface KbCurrentItemProps {
  item: ItemRaisedData | null;
}

/**
 * Where the rep is in the track, as one status line: "Item 2 of 5 · FAQ".
 * The item's guidance itself is in the live-call feed and alerts.
 */
export const KbCurrentItem: React.FC<KbCurrentItemProps> = ({ item }) => {
  if (!item) return <TrainingStatusLine dotClassName="bg-ink-muted">{KB_LIVE_COPY.waitingForItem}</TrainingStatusLine>;

  const itemType = item?.itemType?.toLowerCase() ?? '';
  const typeLabel = KB_ITEM_TYPE_LABEL[itemType] ?? item?.itemType;
  const position = item?.index > 0 ? KB_LIVE_COPY.itemPosition(item.index, item?.totalItems ?? 0) : '';

  return (
    <TrainingStatusLine dotClassName="bg-signature" testId="kb-current-item">
      {[position, typeLabel].filter(Boolean).join(' · ')}
    </TrainingStatusLine>
  );
};

export default KbCurrentItem;
